// extracted by mini-css-extract-plugin
module.exports = {"loading_container":"FullPageLoading_loading_container__1EeHn","headed_loading_container":"FullPageLoading_headed_loading_container__2eVYk"};